export default __webpack_public_path__ + "e4c4578f9b526be2599f9e098c5c4eb2.svg";